export const SET_USER_NAME = 'SET_USER_NAME';
export const SET_USER_LEVEL = 'SET_USER_LEVEL';
export const SET_USER_PORTRAIT_URL = 'SET_USER_PORTRAIT_URL';
export const RESET_USER = 'RESET_USER';
